import { ReactNode } from 'react';

const SheetHeader = ({ children, ...props }: { children: ReactNode }) => {
  return (
    <div className="flex items-center justify-between p-4" {...props}>
      {children}
    </div>
  );
};

export { SheetHeader };
